// extracted by mini-css-extract-plugin
export default {"modalOverlay":"specialModal_modalOverlay__eCQ6h","modalContent":"specialModal_modalContent__o+ryk","closeBtn":"specialModal_closeBtn__1hzU0"};